import { useFormikContext } from 'formik';
import { isEqual, isNil } from 'lodash';

import { Box } from '@hivebrite/design-system/Box';
import { RadiosInput } from '@hivebrite/design-system/Inputs';
import { useMatchBreakpoint } from '@hivebrite/design-system/Theme';

import { useJobContext } from 'hb-react/shared/apps/JobForm/contexts/JobContext';
import {
  Email,
  Text,
} from 'hb-react/shared/components/formik/components/inputs';
import { IsActive } from 'hb-react/shared/components/IsActive';

import { Section } from './Section';
import { type FormValues } from '../types';

export const Apply = () => {
  const { handleChange, values } = useFormikContext<FormValues>();

  const { kindConfigurations = [] } = useJobContext();

  const direction = useMatchBreakpoint('s') ? 'vertical' : 'horizontal';

  const value = values.apply_by;

  const { fields } =
    kindConfigurations.find(({ kind_id: kindId }) =>
      isEqual(kindId, values.kind_id),
    ) || {};

  const inputs = [
    {
      id: 'nothing',
      label: s__('JobForm|No application'),
      name: 'apply_by',
      value: 'nothing',
    },
    {
      id: 'contact_email',
      label: s__('JobForm|Apply by email'),
      name: 'apply_by',
      value: 'contact_email',
    },
    {
      id: 'external_link',
      label: s__('JobForm|Apply through external link'),
      name: 'apply_by',
      value: 'external_link',
    },
  ];

  return (
    <Section
      isActive={fields?.apply_button}
      title={s__('JobForm|Type of application')}
    >
      <>
        <Box display="block" pb={6}>
          <RadiosInput
            direction={direction}
            id="apply_by"
            onChange={handleChange('apply_by')}
            inputs={inputs}
            name="apply_by"
            selectedValue={isNil(value) ? 'nothing' : value}
          />
        </Box>
        <IsActive isActive={value === 'contact_email'}>
          <Box display="block" pb={6}>
            <Email
              id="email"
              label={s__('JobForm|Contact email')}
              name="email"
              validate={{ required: value === 'contact_email' }}
            />
          </Box>
        </IsActive>
        <IsActive isActive={value === 'external_link'}>
          <Box display="block" pb={6}>
            <Text
              id="url"
              label={s__('JobForm|External link of the opportunity')}
              name="url"
              placeholder="https://example.com/jobs"
              validate={{ required: value === 'external_link' }}
            />
          </Box>
        </IsActive>
      </>
    </Section>
  );
};
